export default {"src":"/_next/static/media/blue_arrow_gallery_slide_mobile.37289fd5.svg","height":23,"width":23};